const routeConstants = {
  login: "/login-with-trialpartners",
  dashboard: "/",
  myProfile: "/profile",
  campaigns: "/campaigns",
  insights: "/insights",
  campaignDetails: "/campaign-details",
  manageDataSource: "/manage-data-source",
  reports: "/reports",
  generateReports: "/generate-reports",
  generatedReport: "/reports/generated-report",
  topRecommendedDetailsReport: "/reports/top-recommended-details-report",
  conversions: "/forms",
  conversionsAddForm: "/forms/add-form",
  conversionsUpdateForm: "/forms/edit-form",
  conversionAccountDetails: "/forms/account-details",
  conversionDetails: "/forms/forms-details",
  adCopies: "/ad-copies",
  learnAboutTrialPartners: "/learn-about-trial-partners",
  sendFeedback: "/send-feedback",
  // aboutUs: "/about-us",
  privacyPolicy: "https://trialpartners.co/privacy-policy",
  // privacyPolicy: "/privacy-policy",
};

export default routeConstants;
